import { useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";

const parseSettings = (allStoryblokEntry) => {
  if (!allStoryblokEntry?.edges?.[0]) {
    return [];
  }

  return allStoryblokEntry.edges.map(({ node }) => ({
    ...node,
    content:
      typeof node.content === `string` ? JSON.parse(node.content) : node.content
  }));
};

const useSettings = () => {
  // ---------------------------------------------------------------------------
  // static data

  const { allStoryblokEntry } = useStaticQuery(graphql`
    {
      allStoryblokEntry(filter: { full_slug: { regex: "/_settings/(.*)/" } }) {
        edges {
          node {
            slug
            content
          }
        }
      }
    }
  `);

  const settings = useMemo(
    () => parseSettings(allStoryblokEntry),
    [allStoryblokEntry]
  );

  // ---------------------------------------------------------------------------
  // methods

  const getHeaderNav = () =>
    settings?.[0] ? settings?.find(({ slug }) => slug === `header-nav`) : null;

  const getSideNav = () =>
    settings?.[0] ? settings?.find(({ slug }) => slug === `side-nav`) : null;

  const getFooterNav = () =>
    settings?.[0] ? settings?.find(({ slug }) => slug === `footer-nav`) : null;

  const getPromoBanner = () =>
    settings?.[0]
      ? settings?.find(({ slug }) => slug === `promo-banner`)
      : null;

  const getNewsletterSignup = () =>
    settings?.[0]
      ? settings?.find(({ slug }) => slug === `newsletter-signup-form`)
      : null;

  // ---------------------------------------------------------------------------
  // api

  return {
    settings,
    getHeaderNav,
    getSideNav,
    getFooterNav,
    getPromoBanner,
    getNewsletterSignup
  };
};

export default useSettings;
